import { FC } from "react";

import YellowPlayerCheeringMin from "../../../assets/avatars/avatarsCheering/YellowPlayerCheeringMin.png";
import PinkPlayerCheeringMin from "../../../assets/avatars/avatarsCheering/PinkPlayerCheeringMin.png";
import BluePlayerCheeringMin from "../../../assets/avatars/avatarsCheering/BluePlayerCheeringMin.png";
import GreenPlayerCheeringMin from "../../../assets/avatars/avatarsCheering/GreenPlayerCheeringMin.png";

interface IAvatar {
    avatarColor: string;
}

const AvatarCheering: FC<IAvatar> = ({ avatarColor }) => {

    return (
        <div>
            {avatarColor === "avatar_yellow" && <img className="table_avatar_png_sprint_image table_avatar_animation_duration_cheer" src={YellowPlayerCheeringMin} alt="user_avatar" />}
            {avatarColor === "avatar_pink" && <img className="table_avatar_png_sprint_image table_avatar_animation_duration_cheer" src={PinkPlayerCheeringMin} alt="user_avatar" />}
            {avatarColor === "avatar_blue" && <img className="table_avatar_png_sprint_image table_avatar_animation_duration_cheer" src={BluePlayerCheeringMin} alt="user_avatar" />}
            {avatarColor === "avatar_green" && <img className="table_avatar_png_sprint_image table_avatar_animation_duration_cheer" src={GreenPlayerCheeringMin} alt="user_avatar" />}
        </div>
    )
}

export default AvatarCheering;